import {
  formatContractDate,
  withFallback,
} from "kontrolEdge/helpers/formattersShappedData";
import { shapeCarrierAccess } from "kontrolEdge/helpers/carrierAccess";
import { mapKeListResourceTags } from "kontrolEdge/components/Shared/mapKeListResourceTags";
import type {
  CarrierAccessApiCarrier,
  CarrierAccessApiDetail,
  CarrierAccessApiItem,
} from "./carrierAccess.types";
import type {
  CarrierAccessDetail,
  CarrierAccessItem,
} from "../carrierAccess.types";

/** API → UI mappers (Backbone requests/mappers.ts convention). */

/** Term and Renew Date cells, read the same way Extended PoP reads them. */
function mapTerm(api: CarrierAccessApiItem) {
  const subscription = api.subscription ?? null;
  const renewIso =
    subscription?.renewDate && subscription.renewDate !== "N/A"
      ? subscription.renewDate
      : null;
  const rawDate = renewIso ? new Date(renewIso) : null;

  return {
    term: subscription?.term
      ? `${subscription.term} ${withFallback(subscription.term_unit)}`
      : "-",
    renewDate: renewIso ? formatContractDate(renewIso) : "-",
    renewDateRaw: rawDate && !isNaN(rawDate.getTime()) ? rawDate : null,
    autoRenew: withFallback(subscription?.autoRenew),
    subscriptionStatus: subscription?.status
      ? subscription.status.charAt(0).toUpperCase() +
        subscription.status.slice(1)
      : "-",
  };
}

function mapBase(
  api: CarrierAccessApiItem,
  carriers: CarrierAccessApiCarrier[]
): CarrierAccessItem {
  return {
    id: api.id,
    serviceId: withFallback(api.serviceId),
    name: withFallback(api.name),
    tagsRich: mapKeListResourceTags(api),
    accessType: api.accessType ?? null,
    status: api.status ?? "unknown",
    // The shared helper reads `carrierAccess` off a payload and drops
    // malformed entries, so the list and the Ports view normalize alike.
    carrierAccess: shapeCarrierAccess({ carrierAccess: carriers }),
    endpoints: Array.isArray(api.endpoints) ? api.endpoints : [],
    legCount: api.legCount ?? 0,
    ...mapTerm(api),
    customer: api.customer
      ? {
          name: api.customer.name ?? "-",
          chargebeeCustomerId: api.customer.chargebeeCustomerId ?? "-",
        }
      : undefined,
  };
}

export function mapCarrierAccessApiItemToCarrierAccessDetail(
  api: CarrierAccessApiDetail
): CarrierAccessDetail {
  const legs = Array.isArray(api.legs) ? api.legs : [];
  return {
    ...mapBase(api, legs),
    subscriptionId: api.subscriptionId ?? null,
    tenantId: api.tenantId,
    legs,
    createdAt: api.createdAt ?? null,
    updatedAt: api.updatedAt ?? null,
  };
}
